export enum InfoTableColumnType {
  Text = 'text',
  Boolean = 'boolean',
  Template = 'template',
  Actions = 'actions',
  EditButtons = 'editButtons',
}
